module.exports = __webpack_public_path__ + "img/icon_Arrow_Black.41c63115.svg";